import { render, staticRenderFns } from "./afterAll.vue?vue&type=template&id=7c29cd63&scoped=true&"
import script from "./afterAll.vue?vue&type=script&lang=js&"
export * from "./afterAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c29cd63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c29cd63')) {
      api.createRecord('7c29cd63', component.options)
    } else {
      api.reload('7c29cd63', component.options)
    }
    module.hot.accept("./afterAll.vue?vue&type=template&id=7c29cd63&scoped=true&", function () {
      api.rerender('7c29cd63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/afterSale/afterSale/comp/afterAll.vue"
export default component.exports